export const mergeSavedVisibleColumnOrder = (defaultColumnIds: string[], savedVisibleColumnIds: string[]): string[] => {
    const defaultColumnSet = new Set(defaultColumnIds);
    const seenColumnIds = new Set<string>();
    const sanitizedSavedVisibleColumnIds = savedVisibleColumnIds.filter((id) => {
        if (!defaultColumnSet.has(id) || seenColumnIds.has(id)) return false;
        seenColumnIds.add(id);
        return true;
    });
    const savedVisibleColumnSet = new Set(sanitizedSavedVisibleColumnIds);
    let nextVisibleColumnIndex = 0;

    return defaultColumnIds.map((defaultColumnId) => {
        if (!savedVisibleColumnSet.has(defaultColumnId)) return defaultColumnId;

        const nextVisibleColumnId = sanitizedSavedVisibleColumnIds[nextVisibleColumnIndex];
        nextVisibleColumnIndex += 1;
        return nextVisibleColumnId ?? defaultColumnId;
    });
};
